<template>
  <div class="card">
    <CreateUserModal v-if="showCreateUserModal" @closeModal="closeModal" />
    <DeleteUserModal
      v-if="showDeleteUserModal"
      :userId="userIdSelected"
      @closeModal="closeModal"
    />
    <div class="card-header d-flex align-items-center py-0">
      <h4 class="py-3 mb-0">Usuários</h4>
      <span class="text-muted ms-2 d-none d-sm-none d-md-block">
        Usuários com acesso a plataforma
      </span>
      <div class="ms-auto my-auto">
        <button
          type="button"
          class="btn btn-primary"
          title="Cadastrar Usuário"
          @click="showCreateUserModal = true"
        >
          Cadastrar Usuário
        </button>
      </div>
    </div>
    <LoadingData v-if="isLoadingData" class="my-3" />
    <ListUsers v-else :users="users" @deleteUser="deleteUser" />
  </div>
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import CreateUserModal from '@/components/admin/users/CreateUserModal.vue'
import DeleteUserModal from '@/components/admin/users/DeleteUserModal.vue'
import ListUsers from '@/components/admin/users/ListUsers.vue'

export default {
  name: 'Users',

  components: {
    LoadingData,
    ListUsers,
    CreateUserModal,
    DeleteUserModal,
  },

  data() {
    return {
      isLoadingData: true,
      users: [],
      showCreateUserModal: false,
      showDeleteUserModal: false,
      userIdSelected: null,
    }
  },

  methods: {
    async getUsers() {
      try {
        this.users = await this.$store.dispatch('getUsers')
        this.isLoadingData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    deleteUser(userId) {
      this.userIdSelected = userId
      this.showDeleteUserModal = true
    },

    closeModal(needReload) {
      if (needReload) {
        this.getUsers()
      }
      this.showCreateUserModal = false
      this.showDeleteUserModal = false
    },
  },

  mounted() {
    this.getUsers()
  },
}
</script>
